/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { formatMessage } from "devextreme/localization";
import LoadPanel from "devextreme-react/load-panel";
import { IsPermisionOidRequired } from "../../../redux/actions";
import { responseMiddleware } from "../../../redux/reducers";
import LeaveSummaryTableList from "./LeaveSummaryTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";

export default function LeaveSummaryList() {
  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const history = useHistory();
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (!ReadState && ReadState !== undefined)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("LeaveSummary")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Leave")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("LeaveSummary")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <LeaveSummaryTableList dataGrid={dataGrid} middleware={middleware} />
        </div>
      </div>
    </div>
  );
}
